import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/constants/global-constants';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config-service';
import { HttpClientWrapperService } from 'src/app/services/http-client-wrapper.service';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent implements OnInit {
block : any;
  constructor(
    private subject: SubjectService,
    private router: Router,
    private auth: AuthService,
     public http: HttpClientWrapperService,
    private config: ConfigService
  ) { }

  drmDetails
  profileFlag = false;
  logFlag = false;
  reportFlag = false;
  communicationsFlag = false;
  pluginsFlag = false;
  contentFlag = false;
  manageFlag = false;
  settingsFlag = false;
  accountsFlag = false;
  showMobileFlag = false;
  channelsFlag  = false;
  stbFlag = false;
  smsFlag = false;
  ngOnInit(): void {
    this.http.block.subscribe((value: boolean) => {
      this.block = value
    });
    this.screenWidthDetect();
    this.getDRMVersionDetails();
  }

  getDRMVersionDetails(){
    const url = this.config.json.apiEndpoint + `getDrmVersionDetails${this.config.json.apiEndpointSuffix}`;
    console.log(url);
    this.http.get(url).subscribe({
      next: (data) => {
        this.drmDetails = data;
        localStorage.setItem('version' , this.drmDetails.version);
      },
      error : (error) => {
        console.log(error);
        this.drmDetails = {
          version : '---'
        };
      }
    });
  }

  // openProfile(): void {
  //   this.profileFlag = true;
  // }

  openMenu(str: string): void {
    switch (str) {
      case 'manage':
        this.manageFlag = !this.manageFlag;
        this.profileFlag = false;
        this.logFlag = false;
        this.reportFlag = false;
        this.communicationsFlag = false;
        this.pluginsFlag = false;
        this.contentFlag = false;
        this.settingsFlag = false;
        this.accountsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = false;
        this.smsFlag = false;
        break;
        case 'profile':
          this.profileFlag = !this.profileFlag;
          this.smsFlag = false;
          this.manageFlag = false;
          this.logFlag = false;
        this.reportFlag = false;
        this.communicationsFlag = false;
        this.pluginsFlag = false;
        this.contentFlag = false;
        this.settingsFlag = false;
        this.accountsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = false;
        break;
      case 'logs':
        this.smsFlag = false;
        this.logFlag = !this.logFlag;
        this.manageFlag = false;
        this.profileFlag = false;
        this.reportFlag = false;
        this.communicationsFlag = false;
        this.pluginsFlag = false;
        this.contentFlag = false;
        this.settingsFlag = false;
        this.accountsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = false;
        break;
      case 'reports':
        this.smsFlag = false;
        this.reportFlag = !this.reportFlag;
        this.manageFlag = false;
        this.profileFlag = false;
        this.logFlag = false;
        this.communicationsFlag = false;
        this.pluginsFlag = false;
        this.contentFlag = false;
        this.settingsFlag = false;
        this.accountsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = false;
        break;
        case 'communications':
        this.smsFlag = false;
        this.communicationsFlag = !this.communicationsFlag;
        this.manageFlag = false;
        this.profileFlag = false;
        this.logFlag = false;
        this.reportFlag = false;
        this.pluginsFlag = false;
        this.contentFlag = false;
        this.settingsFlag = false;
        this.accountsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = false;
        break;
        case 'plugin':
          this.smsFlag = false;
          this.pluginsFlag = !this.pluginsFlag;
          this.manageFlag = false;
          this.profileFlag = false;
          this.logFlag = false;
          this.reportFlag = false;
        this.communicationsFlag = false;
        this.contentFlag = false;
        this.settingsFlag = false;
        this.accountsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = false;
        break;
      case 'content':
        this.smsFlag = false;
        this.contentFlag = !this.contentFlag;
        this.manageFlag = false;
        this.profileFlag = false;
        this.logFlag = false;
        this.reportFlag = false;
        this.communicationsFlag = false;
        this.pluginsFlag = false;
        this.settingsFlag = false;
        this.accountsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = false;
        break;
      case 'settings':
        this.smsFlag = false;
        this.settingsFlag = !this.settingsFlag;
        this.manageFlag = false;
        this.profileFlag = false;
        this.logFlag = false;
        this.reportFlag = false;
        this.communicationsFlag = false;
        this.pluginsFlag = false;
        this.contentFlag = false;
        this.accountsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = false;
        break;
        case 'accounts':
          this.smsFlag = false;
          this.accountsFlag = !this.accountsFlag;
          this.manageFlag = false;
        this.profileFlag = false;
        this.logFlag = false;
        this.reportFlag = false;
        this.communicationsFlag = false;
        this.pluginsFlag = false;
        this.contentFlag = false;
        this.settingsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = false;
        break;
        case 'channels' :
          this.smsFlag = false;
          this.accountsFlag = false;
          this.manageFlag = false;
          this.profileFlag = false;
        this.logFlag = false;
        this.reportFlag = false;
        this.communicationsFlag = false;
        this.pluginsFlag = false;
        this.contentFlag = false;
        this.settingsFlag = false;
        this.channelsFlag = !this.channelsFlag;
        this.stbFlag = false;
        break;
        case 'stb' :
          this.smsFlag = false;
        this.accountsFlag = false;
        this.manageFlag = false;
        this.profileFlag = false;
        this.logFlag = false;
        this.reportFlag = false;
        this.communicationsFlag = false;
        this.pluginsFlag = false;
        this.contentFlag = false;
        this.settingsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = !this.stbFlag;
        break;
        case 'sms' :
        this.accountsFlag = false;
        this.manageFlag = false;
        this.profileFlag = false;
        this.logFlag = false;
        this.reportFlag = false;
        this.communicationsFlag = false;
        this.pluginsFlag = false;
        this.contentFlag = false;
        this.settingsFlag = false;
        this.channelsFlag = false;
        this.stbFlag = false;
        this.smsFlag = !this.smsFlag
        break;
    }
  }

  mobileMenu(): void {
    this.showMobileFlag = !this.showMobileFlag;
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if(window.innerWidth > 790){
      this.showMobileFlag = true;
    }
  }


  screenWidthDetect(): void {
    if (window.innerWidth < 768) {
      this.showMobileFlag = false;
      //console.log(screen.width);

    }
    else {
      this.showMobileFlag = true;
    }
  }

  logout(): void {
    window.localStorage.removeItem(GlobalConstants.access);
    this.subject.setAccessSubject(false);

    this.auth.logout();
    this.router.navigate(['login']);
  }

}

